import { useQuery } from "@tanstack/react-query";
import { Link } from "react-router-dom";
import { DocumentStatus, IncludedDocuments } from "@/briefpoint-client";
import { useDocumentApi } from "@/hooks/useApi";
import type { DocumentResponse } from "@/lib/types";
import { addUploadDate } from "@/lib/utils";
import Loading from "../Loading";
import styles from "./ArchiveDocumentList.module.scss";
import { ArchiveDocumentRow } from "./ArchiveDocumentRow";

export default function ArchiveDocumentList() {
  const documentApi = useDocumentApi();

  const archivedDocumentsQuery = useQuery({
    queryKey: ["archivedDocuments"],
    queryFn: async () => {
      return (await documentApi.documentGetList({
        includedDocuments: IncludedDocuments.Archived,
      })) as DocumentResponse[];
    },
    select: (data) =>
      data
        .map((d) => addUploadDate(d))
        .filter((d) => d.status !== DocumentStatus.Error),
  });

  /* optimistically update the documents list */
  return (
    <Loading isLoading={archivedDocumentsQuery.isLoading}>
      {archivedDocumentsQuery.data?.length ? (
        <table id="document-list-table" className={styles.documentListTable}>
          <thead>
            <tr>
              <th />
              <th>Document Name</th>
              <th>Case Number</th>
              <th>Document Type</th>
              <th>Upload Date</th>
              <th>Status</th>
              <th />
              <th />
            </tr>
          </thead>
          <tbody>
            {archivedDocumentsQuery.data?.map((doc) => (
              <ArchiveDocumentRow
                key={doc.id}
                document={doc}
                updateDocuments={archivedDocumentsQuery.refetch}
              />
            ))}
          </tbody>
        </table>
      ) : (
        <p>
          You have no archived documents. Please upload a document{" "}
          <Link to="/documents">here</Link>
        </p>
      )}
    </Loading>
  );
}
